import { Avatar } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate, isCurrentDateInWeek } from '../functions/formatDate';
import { getUserInitials } from '../functions/getUserInitials';

export const useOfficeOrderlyColumns = (): GridColDef[] => {
  const { t } = useTranslation();
  return [
    { field: 'id', headerName: t('general.id'), width: 50 },
    {
      field: 'startDate',
      width: 150,
      headerName: t('general.startDate'),
      renderCell: (params: GridRenderCellParams<any, any, any>) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {formatDate(params.value)}
        </div>
      ),
    },
    {
      field: 'user',
      headerName: t('general.user'),
      flex: 1,
      renderCell: (params: GridRenderCellParams<any, any, any>) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Avatar
              style={{ marginRight: '8px' }}
              src={params.row?.user?.profilePhoto?.thumbnail}
            >
              {getUserInitials(params.row.user)}
            </Avatar>
            {params.row?.user.displayName}
          </div>
        );
      },
    },
    {
      field: 'active',
      width: 220,
      headerName: t('officeOrderly.currentOrderly'),
      renderCell: (params: GridRenderCellParams<any, any, any>) => {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            {isCurrentDateInWeek(params.row?.startDate) && (
              <VerifiedIcon color={'primary'} />
            )}
          </div>
        );
      },
    },
  ];
};
